import { parsePayloadForQuery } from '@/helpers/utils.js';
import axios from 'axios';
import Vue from 'vue';

export const MODAL_NAME = {
  CREATE: 'create',
  EDIT_DETAILS: 'editDetails',
}

const state = {
  items: [],
  modals: {
    create: false,
    editDetails: false
  },
  item: null
};

const getters = {
  getCompany: state => state.item,
  getCompanies: state => state.items,
  isCreateOpen: state => state.modals.create,
  isEditDetailsOpen: state => state.modals.editDetails
};

const mutations = {
  itemsLoaded(state, payload) {
    state.items = payload;
  },
  itemLoaded(state, payload) {
    state.item = payload;
  },
  open(state, modalName) {
    Vue.set(state.modals, modalName, true);
  },
  close(state, modalName) {
    Vue.set(state.modals, modalName, false);
  },
};

const actions = {
  get(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/companies${queryParams}`);
  },
  getUsers(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/companies/users${queryParams}`);
  },
  create(state, payload) {
    return axios.post(`/companies`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Create company - ERROR - ', data.failures[0].error);
          throw data.failures[0];
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  edit(state, payload) {
    return axios.patch(`/companies`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit company - ERROR - ', data.failures[0].error);
          throw data.failures[0];
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  delete(state, payload) {
    return axios.delete(`/companies?ids=${payload}`)
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};